import { createMixpanelAnalyticsClient } from '@satellite/analytics/createMixpanelAnalyticsClient';
import type { AnalyticsClient } from '@satellite/composables/useAnalytics';
import config from '@/config/config';

/**
 * Builds the Mixpanel client Circe provides through `analyticsKey`.
 *
 * Session Replay is sampled rather than driven by hand: the gate configured here decides,
 * and the router asks the client to act on that decision after every navigation.
 */
export function createCirceAnalyticsClient(): AnalyticsClient {
  return createMixpanelAnalyticsClient({
    token: config.mixpanel_token,
    serverEnv: config.server_env,
    sessionReplay: {
      recordMaxMs: config.mixpanel_session_replay_max_ms,
      recordIdleTimeoutMs: config.mixpanel_session_replay_idle_timeout_ms,
      gate: {
        // The stored object carries its own schema version (GATE_STATE_VERSION); the key does not.
        storageKey: 'od:session_replay_gate:circe',
        pathPrefix: '/tasks',
        enabled: config.mixpanel_session_replay_enabled,
        samplePercent: config.mixpanel_session_replay_sample_percent
      }
    }
  });
}
